module.exports = __webpack_public_path__ + "img/como-funciona-relink-3.88e819e.webp";